/**
 * Yvine Design — product page (thumbnails, lightbox, variants, quantity, add to cart).
 * Cached asset, initialised once per [data-art="product"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('product', function (root) {
    var sid = root.getAttribute('data-section-id');

    var dataEl = document.querySelector('script[data-pdp-variants="' + sid + '"]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    var form = root.querySelector('[data-pdp-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var stageImg = root.querySelector('[data-stage-img]');

    /* ---- Gallery thumbnails (images, videos, YouTube) ---- */
    var stageEl = root.querySelector('[data-stage]');
    var player = root.querySelector('[data-stage-player]');

    // Nothing plays until a thumbnail asks for it: no <video>, no iframe and so
    // no YouTube payload on page load.
    function closePlayer() {
      if (!player) return;
      player.innerHTML = '';
      player.hidden = true;
      if (stageEl) stageEl.classList.remove('has-player');
    }

    function openPlayer(node) {
      if (!player) return;
      player.innerHTML = '';
      player.appendChild(node);
      player.hidden = false;
      if (stageEl) stageEl.classList.add('has-player');
    }

    function playVideo(src) {
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.autoplay = true;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      openPlayer(v);
    }

    function playExternal(id, host) {
      var frame = document.createElement('iframe');
      frame.src = (host === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
        : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
      frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.loading = 'lazy';
      frame.title = document.title;
      openPlayer(frame);
    }

    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!stageImg) return;
        var full = btn.getAttribute('data-full');
        var full2x = btn.getAttribute('data-full-2x');
        var zoom = btn.getAttribute('data-zoom');
        stageImg.src = full;
        stageImg.srcset = full + ' 1200w, ' + (full2x || full) + ' 1800w';
        if (zoom) stageImg.setAttribute('data-zoom', zoom);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var video = btn.getAttribute('data-video');
        var yt = btn.getAttribute('data-youtube');
        if (video) playVideo(video);
        else if (yt) playExternal(yt, btn.getAttribute('data-youtube-host'));
        else closePlayer();
      });
    });

    /* ---- Lightbox (click stage → full-size) ---- */
    var stage = stageEl;
    // Full-size view goes through the one shared lightbox.
    function openLightbox() {
      if (!window.ArtLightbox || !stageImg) return;
      // Same as the article poster: open the copy the page already has when it
      // is big enough, rather than fetching a second rendition of it.
      var full = window.ArtLightbox.pick(stageImg, stageImg.getAttribute('data-zoom'));
      if (!full) return;
      window.ArtLightbox.open({ media: [{ kind: 'image', url: full, thumb: full }], title: stageImg.alt || '' });
    }
    if (stageEl) stageEl.addEventListener('click', function (e) {
      // ignore clicks on the timelapse video controls, and anything inside the
      // player — a click on a video's scrubber is not a request to zoom
      if (e.target.closest('[data-art-timelapse]')) return;
      if (e.target.closest('[data-stage-player]')) return;
      openLightbox();
    });

    /* ---- Variant switching ---- */
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input[data-option-input]:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateVariant() {
      if (!variants.length) return;
      var opts = selectedOptions();
      var v = opts.length ? findVariant(opts) : variants[0];
      if (!v) v = variants[0];

      idInput.value = v.id;

      // Price
      if (priceEl) {
        if (v.on_sale) {
          priceEl.innerHTML = '<span class="art-pdp__price-now">' + v.price + '</span> <s class="art-pdp__price-was">' + v.compare_at_price + '</s>';
        } else {
          priceEl.textContent = v.price;
        }
      }

      // Availability
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          if (atcText) atcText.textContent = atc.getAttribute('data-add-label') || atcText.textContent;
          atc.classList.remove('is-unavailable');
        } else {
          atc.disabled = true;
          if (atcText) atcText.textContent = atc.getAttribute('data-soldout-label') || atcText.textContent;
          atc.classList.add('is-unavailable');
        }
      }

      // Swap stage image to the variant's media when it has one
      if (v.media_full) closePlayer();
      if (stageImg && v.media_full) {
        stageImg.src = v.media_full;
        stageImg.srcset = '';
        stageImg.setAttribute('data-zoom', v.media_full.replace(/width=\d+/, 'width=2400'));
      }
    }

    if (atcText) atc.setAttribute('data-add-label', atcText.textContent.trim());
    root.querySelectorAll('input[data-option-input]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    /* ---- Quantity stepper ---- */
    var qtyInput = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    function clampQty() {
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      qtyInput.value = n;
    }
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    /* ---- Add to cart (fetch → header badge/sparkle hook into /cart/add.js) ---- */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      atc.classList.add('is-loading');
      atc.classList.remove('is-added');
      fetch(root.getAttribute('data-cart-url') + '/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          atc.classList.remove('is-loading');
          if (res.ok) {
            atc.classList.add('is-added');
            clearTimeout(atc._t);
            atc._t = setTimeout(function () { atc.classList.remove('is-added'); }, 2000);
          }
        })
        .catch(function () { atc.classList.remove('is-loading'); });
    });
});
